import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GenericDD } from 'src/app/model/generic-data';
import { infoAnagrafiche } from 'src/app/model/global-interface';
import { MDAdd, genericMD, mdLenght, mdResponse } from 'src/app/model/masterdata/masterdata';
import { BaseResponse } from 'src/app/model/response/base-response';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class MasterdataService {

  private url: string = `${environment.apiUrl}`;
  private baseUrl: string = `${environment.apiUrl}/sla`;

  private tables: Array<string> = ['tipologia-cliente', 'unita-misura','categoria-fornitore','categorie','settori','settori-cliente','sedi', 'sla','tipologia-attivita','priorita', 'area-ticket'];
  //tabelle femminili per mettere l'articolo femminile nei messaggi tradotti in italiano
  private femTables: Array<string> = ['tipologia-cliente','unita-misura','categoria-fornitore','categorie','sedi', 'sla','tipologia-attivita','priorita', 'area-ticket'];
  //tabelle che iniziano con una vocale e quindi necessitano dell'apostrofo
  private specialTables: Array<string> = ['unita-misura'];

  constructor(private http: HttpClient) { }


  /**
   * Return the array with all the Master data
   */
  getMasterDataArray(): string[] {
    return this.tables;
  }



  getFemArray(): string[] {
    return this.femTables;
  }


  getSpecialArray(): string[] {
    return this.specialTables;
  }


  getInfo(): Observable<infoAnagrafiche[]> {
    return this.http.get<infoAnagrafiche[]>(`${this.url}/rows/masterdata/info`);
  }

  getTitleFromUrl(url:string){
    url=url.replaceAll('-', ' ');
    return url.charAt(0).toUpperCase() + url.slice(1)
  }

  getTableFromUrl(url:string){
    url=url.replaceAll('-', ' ');
    return url.replaceAll(/\s/g, "")
  }

  getRows(table:string): Observable<any> {
    return this.http.get<any>(`${this.url}/rows/getrows/${table}`);
  }


  getAll(table:string):Observable<genericMD[]>{
    return this.http.get<genericMD[]>(`${this.url}/${table}/getall`);
  }

  getLazy(table:string,offset:number,max:number):Observable<genericMD[]>{
    return this.http.get<genericMD[]>(`${this.url}/${table}/get/lazy/${offset}/${max}`);
  }

  getById(id:number,table:string):Observable<genericMD>{
    return this.http.get<genericMD>(`${this.url}/${table}/getid/${id}`);
  }

  getByCodice(codice:string,table:string):Observable<genericMD>{
    return this.http.get<genericMD>(`${this.url}/${table}/get/codice/${codice}`);
  }

  edit(md:genericMD,table:string):Observable<BaseResponse>{
    return this.http.put<BaseResponse>(`${this.url}/${table}/update/${md.id}`,md);
  }

  setState(id:number,state:boolean,table:string):Observable<boolean>{
    let url = `${this.url}/${table}/setstate/${id}/${state}`
    if(table=='servizicontratti')
    url=`${this.url}/${table}/state/set/${id}/${state}`,null
    return this.http.put<boolean>(url,null);
  }

  add(md:genericMD,table:string):Observable<mdResponse>{
    return this.http.post<mdResponse>(`${this.url}/${table}/add/`,md);
  }

  clone(id:string,table:string,username:string):Observable<BaseResponse>{
    return this.http.post<BaseResponse>(`${this.url}/${table}/clone/${id}/${username}`, username);
  }

  getLenght(table:string):mdLenght{
    switch(table){
      case 'condizionipagamento':{
        console.log(table)
        return {codice:100,descrizione:3000};
        break;
      }
      case 'diametrobobine':{
        console.log(table)
        return {codice:100,descrizione:500};
        break;
      }
      case 'categoriafornitore':{
        console.log(table)
        return {codice:100,descrizione:500};
        break;
      }
      case 'naturamerce':{
        console.log(table)
        return {codice:100,descrizione:1000};
        break;
      }
      case 'tipologiacliente':{
        console.log(table)
        return {codice:100,descrizione:1000};
        break;
      }
      case 'tipomezzo':{
        console.log(table)
        return {codice:100,descrizione:1000};
        break;
      }
      case 'zone':{
        console.log(table)
        return {codice:100,descrizione:100};
        break;
      }
      case 'accessori': {
        console.log(table);
        return {codice: 100, descrizione: 10000};
        break;
      }
      case 'unitamisura': {
        console.log(table);
        return { codice: 100, descrizione: 1000 };
        break;
      }
      case 'consegnariserva': {
        console.log(table);
        return { codice: 100, descrizione: 1000 }
        break;
      }
      case 'consegnarifiutata': {
        console.log(table);
        return { codice: 100, descrizione: 1000 }
        break;
      }
      case 'consegnanoneffettuata': {
        console.log(table);
        return { codice: 100, descrizione: 1000 }
        break;
      }

      default:{
        console.log('error')
        return {codice:0,descrizione:0};
        break;
      }
    }
  }


  checkLock(id:number,table:string):Observable<BaseResponse>{
    return this.http.get<BaseResponse>(`${this.url}/${table}/lockcheck/${id}`);
  }

  setLock(id:number,table:string,username?:string):Observable<any>{
    console.log(username)
    let url = `${this.url}/${table}/setlock/${id}?`;
    if(username != null) {
      url= url+`username=${username}`;
    }
    return this.http.put<any>(url,null);
  }


  getTipologiaClienteDD(): Observable<Array<GenericDD>> {
    return this.http.get<Array<GenericDD>>(`${this.url}/tipologiacliente/get/all/dd`);
  }


}
